import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class SingleProductVC extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      image,
      title,
      sku,
      cat,
      desc,
      bestandteile,
      nahrwerte_pro_100g,
      resources_images_url,
      strings,
    } = this.props

    console.log(bestandteile) //eslint-disable-line
    console.log(nahrwerte_pro_100g) //eslint-disable-line
    console.log(strings) //eslint-disable-line

    return (
      <div className="dhsv_vc_single_product">
        <img className="dhsv_vc_single_product__img" src={image} />
        <div className="dhsv_vc_single_product__sku">
          {strings.artnr} {sku}
        </div>
        <div className="dhsv_vc_single_product__cat">{cat}</div>
        <div
          className="dhsv_vc_single_product__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className="dhsv_vc_single_product__desc">{desc}</div>
        {bestandteile && (
          <div className="dhsv_vc_single_product__ingredients">
            {bestandteile.map((bestandteil, i) => (
              <div
                key={i}
                className="dhsv_vc_single_product__ingredients_block"
              >
                <div
                  className="dhsv_vc_single_product__ingredients_img"
                  style={{
                    backgroundImage: `url(${resources_images_url}${bestandteil.bestandteil.value}.png)`,
                  }}
                ></div>
                <div className="dhsv_vc_single_product__ingredients_label">
                  {bestandteil.bestandteil.label}
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="dhsv_vc_single_product__table">
          <div className="dhsv_vc_single_product__table_head">
            {strings.nahrwerte}
          </div>
          <div className="dhsv_vc_single_product__table_content">
            {nahrwerte_pro_100g.map((nahrwert, i) => (
              <div key={i} className="dhsv_vc_single_product__table_row">
                <div className="dhsv_vc_single_product__table_col1">
                  {nahrwert.nahrwert}
                </div>
                <div className="dhsv_vc_single_product__table_col2">
                  {nahrwert.anzahlgewicht}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

SingleProductVC.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  sku: PropTypes.string,
  cat: PropTypes.string,
  desc: PropTypes.string,
  bestandteile: PropTypes.array,
  nahrwerte_pro_100g: PropTypes.array,
  resources_images_url: PropTypes.string,
  strings: PropTypes.object,
}

export default SingleProductVC
